var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass:
        "font-josefin -mb-px font-semibold tracking-wider text-sm sm:text-base leading-8 uppercase py-1 border-b-2 border-transparent transition-color duration-400",
      class: { "border-primary-600": _vm.isActive },
      attrs: { href: "#" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.activateTab.apply(null, arguments)
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }